module.exports = __webpack_public_path__ + "static/img/apply7.49be101f.png";